var map = {
	"./decidim/avatar-multiuser.png": 38836,
	"./decidim/brands/google.svg": 37947,
	"./decidim/cc-badge.png": 8150,
	"./decidim/decidim-logo.svg": 81942,
	"./decidim/default-avatar.svg": 89394,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 60246,
	"./decidim/icons.svg": 10437,
	"./decidim/pattern.png": 9298,
	"./decidim/placeholder-card-g.svg": 30367,
	"./decidim/placeholder-card-l.svg": 73540,
	"./decidim/placeholder.jpg": 61339,
	"./decidim/remixicon.symbol.svg": 28019,
	"./decidim/vendor/leaflet/layers-2x.png": 15990,
	"./decidim/vendor/leaflet/layers.png": 45069,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 84180,
	"./decidim/vendor/leaflet/marker-icon.png": 61715,
	"./decidim/vendor/leaflet/marker-shadow.png": 83496,
	"./decidim/vendor/social-share-button/douban.svg": 71170,
	"./decidim/vendor/social-share-button/email.svg": 21023,
	"./decidim/vendor/social-share-button/facebook.svg": 39457,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3923,
	"./decidim/vendor/social-share-button/hacker_news.svg": 77555,
	"./decidim/vendor/social-share-button/linkedin.svg": 84655,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 5704,
	"./decidim/vendor/social-share-button/pinterest.svg": 32273,
	"./decidim/vendor/social-share-button/reddit.svg": 3681,
	"./decidim/vendor/social-share-button/telegram.svg": 52568,
	"./decidim/vendor/social-share-button/tumblr.svg": 31311,
	"./decidim/vendor/social-share-button/twitter.svg": 60078,
	"./decidim/vendor/social-share-button/vkontakte.svg": 67344,
	"./decidim/vendor/social-share-button/wechat.svg": 55227,
	"./decidim/vendor/social-share-button/whatsapp.svg": 94003,
	"./decidim/vendor/social-share-button/x.svg": 57175,
	"./decidim/vendor/social-share-button/xing.svg": 12865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45025;